export enum ExpandableCardsCollectionVariantEnum {
    CENTERED_PICTURE_BOTTOM = 'CenteredPictureBottom',
    TITLE_OVER_PICTURE = 'TitleOverPicture',
}
